export const pageNames = {
  enterAmount: 'enterAmount',
  errorPage: 'errorPage',
  processing: 'processing',
  loanReview: 'loanReview',
  loanSuccess: 'loanSuccess',
};
